import Section from "../Section";
import Slider from "../global/Slider";

export default class Slideshow extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.sliderElement = element.querySelector('.flexslider-homepage');

    this.slider = new Slider(theme, this.sliderElement);
  }

    onBlockSelect = ({ element }) => {
      const index = parseInt(element.dataset.slideIndex, 10);
      this.slider.showSlide(index);
    }

    onBlockDeselect = () => {
      this.slider.startAnimation();
    }
}
